<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				Edit Deal Pack
			</div>
		</div>
		<div class="separator" />
		<div class="content edit-deal-pack">
			<div class="main">
				<v2-deal-pack-edit
					ref="editRef"
					:dealPackId="getDealPackId"
					:cancelRoute="getCancelRoute"
					:isCreate="false"
					:entryRoute="'admin'"
				/>
			</div>
			<div class="side">

				<div class="edit-deal-pack--title">
					<icon icon="v2-teacher" colour="transparent" />
					Edit Deal Pack
				</div>

				<div class="edit-deal-pack--controls">
					<V2Button variant="red" @click="onCreate">
						Save
					</V2Button>
					<V2Button @click="onCancel">
						Cancel
					</V2Button>
				</div>

			</div>
		</div>
	</div>
</template>

<route>
{
	"meta": {
		"isAdminOnly": true
	}
}
</route>

<script>
	import Icon               from '@/components/ui/Icon';
	import V2BackBtn          from '@/components/v2/ui/V2BackBtn';
	import V2Button           from '@/components/v2/ui/V2Button';
	import V2DealPackEdit     from '@/components/dealPacks/V2DealPackEdit.vue';

	export default {
		metaInfo: {
			title: 'Edit Deal Pack'
		},

		components: {
			V2BackBtn,
			Icon,
			V2Button,
			V2DealPackEdit
		},

		layout: 'v2default',

		computed: {
			getCancelRoute () {
				if (!this.getDealPackId) {
					return false;
				}
				return `/admin/deal-packs/${this.getDealPackId}`;
			},

			getDealPackId () {
				return this.$route.params.dealPackId;
			}
		},

		created () {
			this.$store.commit('ui/setLoadingIsHidden');
		},

		methods: {
			onCreate () {
				this.$refs.editRef.submit();
			},

			onCancel () {
				this.$router.back();
			}
		}
	};
</script>

<style lang="scss" scoped>

.edit-deal-pack {
  &--title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 10px;
    @include font(18px, $c-darkest-navy, 700, 23px);
  }

  &--controls {
    display: flex;
    gap: 12px;

    .btn {
      border-radius: 4px;
      padding: 8px 20px;
      @include font(16px, $c-white-l, 500, 20px);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-create {
      background: $c-red;
    }

    &-cancel {
      background: $c-dark-navy;
    }
  }
}

</style>
